export const environment = {
  production: false,
  apiUrl: 'https://southlake.dev.falconsystem.com/api',
};
